import { Icon } from '@adobe/react-spectrum';

const ChevronDownIcon = props => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10.6719 13.3616L16.0039 8.02954C16.373 7.65845 16.373 7.05688 16.0039 6.68579C15.6328 6.31567 15.0312 6.31567 14.6602 6.68579L10 11.346L5.33984 6.68579C4.96875 6.31567 4.36718 6.31567 3.99609 6.68579C3.81152 6.87134 3.71875 7.1145 3.71875 7.35767C3.71875 7.60084 3.81152 7.844 3.99609 8.02955L9.32812 13.3616C9.69921 13.7317 10.3008 13.7317 10.6719 13.3616Z"
          fill="#222222"
        />
      </svg>
    </Icon>
  );
};

export default ChevronDownIcon;
